import {REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS} from "../../../../middlewares/api/actions";
import {
    CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISATION_DELETE_MAPPING_SET,
    CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISE_MAPPING_SET,
    CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_TO_CATEGORIZE_MAPPING_SET,
    CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_LANGUAGE_CHANGE_MAPPING_SET,
    CATEGORY_SCHEMES_AND_DATAFLOWS_TREE_READ_MAPPING_SET,
} from "./actions";
import {
    CATEGORY_SCHEME_ORDER_ANNOTATION_KEY,
    getArtefactFromSdmxJsonStructure,
    getItemFromSdmxJsonStructure,
    getNodeFromMappingSet,
    getSdmxStructuresFromSdmxJson,
    getStringFromArtefactTriplet,
    getTypeFromArtefact,
    getUrnFromArtefact,
    SDMX_JSON_CATEGORISATION_LIST_KEY,
    SDMX_JSON_CATEGORY_SCHEME_LIST_KEY,
    SDMX_JSON_DATAFLOW_LIST_KEY,
} from "../../../../utils/sdmxJson";
import {
    getCategorisedObjectsTree,
    getFilteredTree,
    getMappedTree,
    UNCATEGORIZED_CATEGORY_CODE
} from "../../../../utils/tree";
import {getCurrentNodeConfig} from "../../../../middlewares/current-node-config/middleware";
import {getOrderedChildren} from "../../../../utils/artefacts";
import {categorisationsSorterFactory, getMappingSetsForDataflow} from "./utils";
import {APP_LANGUAGE_SET} from "../../../../reducers/app/actions";
import { getLocalizedStr } from "../../../../middlewares/i18n/utils";

const initialState = {
    tree: null,
    categorisations: null,
    toCategorizeDataflow: null,
    dataflows: null,
    mappingSets:null,
    requestSuccess: false,
    annotations: null
};

const mappingSetTreeReducer = (
    state = {
        ...initialState
    },
    action
) => {
    switch (action.type) {
        case APP_LANGUAGE_SET:
            if (state.tree && state.categorisations) {
              
                const newTree = getMappedTree(state.tree, "categories", node => {
                    if (node.urn && node.categories && node.categories.length) {
                        return {
                            ...node,
                            categories: [
                                ...node.categories.filter(({type}) => type !== "dataflow"),
                                ...node.categories.filter(({type}) => type === "dataflow").sort((a, b) => {

                                    return categorisationsSorterFactory(getCurrentNodeConfig(action).annotations.categorisationsOrder.type, action.payload.language)(
                                        state.categorisations.find(({
                                                                        source,
                                                                        target
                                                                    }) => source === a.urn && target === node.urn),
                                        state.categorisations.find(({
                                                                        source,
                                                                        target
                                                                    }) => source === b.urn && target === node.urn)
                                    );
                                })
                            ]
                        }
                    } else {
                        return node;
                    }
                });

                return {
                    ...state,
                    tree: newTree,
                    toCategorizeDataflow: null,
                };
            } else {
                return {
                    ...initialState,
                }
            }
        case CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_LANGUAGE_CHANGE_MAPPING_SET:
            return {
                ...state,
                tree: null,
                toCategorizeDataflow: null,
            };
        case CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_TO_CATEGORIZE_MAPPING_SET:
            return {
                ...state,
                toCategorizeDataflow: action.dataflow
            }
        case REQUEST_START:
            switch (action.label) {
                case CATEGORY_SCHEMES_AND_DATAFLOWS_TREE_READ_MAPPING_SET:
                    return {
                        ...state,
                        tree: null,
                        dataflows: null,
                        mappingSets: null,
                        toCategorizeDataflow: null,
                        requestSuccess: false,
                    };
                default:
                    return state;
            }
        case REQUEST_SUCCESS:
            switch (action.label) {
                case CATEGORY_SCHEMES_AND_DATAFLOWS_TREE_READ_MAPPING_SET:
                    const categorySchemePermissions = action.categorySchemePermissions || [];
                    const showOnlyCategoriesWithDataflows = action.showOnlyCategoriesWithDataflows || false;
										const annotations = getCurrentNodeConfig(action).annotations;
                    const enabledCategoryScheme =
                        (getSdmxStructuresFromSdmxJson(action.response[0], SDMX_JSON_CATEGORY_SCHEME_LIST_KEY) || [])
                            .filter(categoryScheme => categorySchemePermissions.includes(getStringFromArtefactTriplet(categoryScheme)));

                    const categorySchemes =
                        (enabledCategoryScheme || [])
                            .map(artefact => {
                                let categoryScheme = getArtefactFromSdmxJsonStructure(artefact, annotations);
                                categoryScheme.categories = categoryScheme.categories
                                    ? getMappedTree(
                                        categoryScheme.categories,
                                        "categories",
                                        node => getItemFromSdmxJsonStructure(node, annotations, CATEGORY_SCHEME_ORDER_ANNOTATION_KEY)
                                    )
                                    : [];

                                return getMappedTree(
                                    [categoryScheme],
                                    "categories",
                                    node => {
                                        node.categories = getOrderedChildren(
                                            node.categories,
                                            node.id,
                                            action.lang,
                                            annotations[CATEGORY_SCHEME_ORDER_ANNOTATION_KEY]
                                        );
                                        return node
                                    }
                                )[0];
                            });

                    const categorisations =
                        (getSdmxStructuresFromSdmxJson(action.response[0], SDMX_JSON_CATEGORISATION_LIST_KEY) || [])
                            .map(artefact => getArtefactFromSdmxJsonStructure(artefact, annotations));

                    const dataflows =
                        (getSdmxStructuresFromSdmxJson(action.response[1], SDMX_JSON_DATAFLOW_LIST_KEY) || [])
                            .map(artefact => getArtefactFromSdmxJsonStructure(artefact, annotations));


                    const dataflowsWithMappingSets = dataflows.map((dataflow) => {
                        const mappingSetList = getMappingSetsForDataflow(dataflow, action.response[2]);
                        return {
                            ...dataflow,
                            categories: mappingSetList,
                        };
                    });

                    const isDataflowInCategory = (df, cat) => {
                        if (cat)
                            return df.categorisations.filter(({urn}) =>
                                urn === getUrnFromArtefact(cat)
                            ).length > 0;
                        else
                            return (df.categorisations.length > 0);
                    };

                    let tree = getCategorisedObjectsTree(
                        dataflowsWithMappingSets
                            .map(dataflow => ({
                                ...dataflow,
                                categorisations:
                                    categorisations
                                        .filter(({source}) => source === dataflow.urn)
                                        .map(({target, autoAnnotations}) => ({
                                            urn: target,
                                            order: autoAnnotations
                                                ? (autoAnnotations.find((ann) =>
                                                    (ann && ann.type === annotations.categorisationsOrder.type)) || null)
                                                : null
                                        }))
                            })),
                        categorySchemes,
                        'categories',
                        (a, b, cat) => {

                            const aOrder = (a.categorisations.find(({urn}) => urn === getUrnFromArtefact(cat)) || {}).order;
                            const bOrder = (b.categorisations.find(({urn}) => urn === getUrnFromArtefact(cat)) || {}).order;

                            if (aOrder && aOrder.text && aOrder.text[action.lang] && bOrder && bOrder.text && bOrder.text[action.lang]) {
                                return Number(aOrder.text[action.lang]) - Number(bOrder.text[action.lang]);
                            } else {
                                return 0;
                            }
                        },
                        isDataflowInCategory,
                        'id',
                        'name',
                        false
                    );

                    const root = [{
                        isRoot: true,
                        categories: tree
                    }];

                    tree = getMappedTree(root, "categories", node => {
                        if (!node.isRoot && node.id !== UNCATEGORIZED_CATEGORY_CODE && getTypeFromArtefact(node) !== "categoryscheme" && node.categories) {
                            node.categories = node.categories.map(cat => ({
                                ...cat,
                                categoryUrn: getUrnFromArtefact(node)
                            }));
                        }
                        if (!node.isRoot && node.id !== UNCATEGORIZED_CATEGORY_CODE) {
                            node.urn = getUrnFromArtefact(node);
                            node.type = getTypeFromArtefact(node);
                        }
                        return node
                    })[0].categories;

                    tree = getMappedTree(tree, "categories", node => {
												// Generate key for the node
												node.treeKey = node.id === UNCATEGORIZED_CATEGORY_CODE
													? UNCATEGORIZED_CATEGORY_CODE
													: getNodeFromMappingSet(node, tree, annotations, action.t, getLocalizedStr, action.lang, action.dataLanguages);

                        if (node.urn && node.categories && node.categories.length) {
                            return {
                                ...node,
                                categories: [
                                    ...node.categories.filter(({type}) => type !== "dataflow" && type !== "category"),
                                    ...node.categories.filter(({type, annotations}) => type === "category" && !annotations),
                                    ...node.categories.filter(({type, annotations}) => type === "category" && !!annotations).sort((a, b) => {
                                        return categorisationsSorterFactory("CategoryScheme_node_order", action.lang, "annotations")({
                                            autoAnnotations: a.annotations.map(item => ({...item, text: item.texts}))
                                        }, {
                                            autoAnnotations: b.annotations.map(item => ({...item, text: item.texts}))
                                        });
                                    }),
                                    ...node.categories.filter(({type}) => type === "dataflow").sort((a, b) => {
                                        return categorisationsSorterFactory(annotations.categorisationsOrder.type, action.lang)(
                                            categorisations.find(({
                                                                      source,
                                                                      target
                                                                  }) => source === a.urn && target === node.urn),
                                            categorisations.find(({
                                                                      source,
                                                                      target
                                                                  }) => source === b.urn && target === node.urn)
                                        );
                                    })
                                ]
                            }
                        } else {
                            return node;
                        }
                    });
                    if (showOnlyCategoriesWithDataflows) {
                        const catWithDFs = categorisations.map(item => item.target.replace("urn:sdmx:org.sdmx.infomodel.categoryscheme.Category=", "")).join("+");
                        tree = getFilteredTree(tree, "categories", node => node.id === UNCATEGORIZED_CATEGORY_CODE || !node.type.includes("category") || catWithDFs.includes(node.id))
                    }

                    return {
                        ...state,
                        tree: tree,
                        categorisations: categorisations,
                        dataflows: action.response[1].data.dataflows,
                        mappingSets: action.response[2],
                        toCategorizeDataflow: null,
                        annotations,
                    };
                case CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISE_MAPPING_SET:
                    return {
                        ...state,
                        tree: null,
                        toCategorizeDataflow: null,
                    };
                case CATEGORY_SCHEMES_AND_DATAFLOWS_DATAFLOW_CATEGORISATION_DELETE_MAPPING_SET:
                    return {
                        ...state,
                        tree: null,
                        toCategorizeDataflow: null,
                    };
                default:
                    return state;
            }
        case REQUEST_ERROR:
            switch (action.label) {
                default:
                    return {
                        ...state,
                        toCategorizeDataflow: null,
                    }
            }
        default:
            return state;
    }
};

export default mappingSetTreeReducer;
